import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/translation/en.json";
import translationNL from "./locales/translation/nl.json";

const resources = {
  en: {
    translation: translationEN.translation,
  },
  nl: {
    translation: translationNL.translation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "nl", // default language is dutch
    lng: "nl",         // initialize with Dutch
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
